// import React from "react";
// import { useNavigate } from "react-router-dom";

// const ChooseRole = () => {
//   const navigate = useNavigate();

//   const roles = [
//     {
//       title: "Property Owner",
//       desc: "List and sell your land plots",
//       bg: "#16a34a",
//       icon: "🏠",
//       role: "owner"
//     },
//     {
//       title: "Investor",
//       desc: "Find and invest in properties",
//       bg: "#2563eb",
//       icon: "📈",
//       role: "investor"
//     },
//     {
//       title: "Agent",
//       desc: "Connect buyers and sellers",
//       bg: "#db2777",
//       icon: "💼",
//       role: "agent"
//     }
//   ];

//   return (
//     <div style={styles.container}>
//       {/* Header */}
//       <div style={styles.header}>
//         <span style={styles.back} onClick={() => navigate(-1)}>← Back</span>
//       </div>

//       {/* Title */}
//       <h1 style={styles.title}>Choose Your Role</h1>
//       <p style={styles.subtitle}>
//         Select how you want to use PlotHub "."
//       </p>

//       {/* Cards */}
//       <div style={styles.cardWrapper}>
//         {roles.map((item, index) => (
//           <div
//             key={index}
//             style={styles.card}
//             onClick={() => navigate(`/signup/${item.role}`)}
//           >
//             <div
//               style={{
//                 ...styles.iconBox,
//                 backgroundColor: item.bg
//               }}
//             >
//               <span style={styles.icon}>{item.icon}</span>
//             </div>

//             <div>
//               <h3 style={styles.cardTitle}>{item.title}</h3>
//               <p style={styles.cardDesc}>{item.desc}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ChooseRole;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./MainLandingPage.css";
import mapImg from "../assets/live.jpeg";
import logo from "../assets/d37h13dk.png";
import FadeInSection from "../FadeInSection/FadeInSection";
import { AiOutlineHome } from "react-icons/ai";
import { BsGraphUpArrow } from "react-icons/bs";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { State, City } from "country-state-city";
import axios from "axios";

const ChooseRole = () => {
    const navigate = useNavigate();
    const [hoverIndex, setHoverIndex] = useState(null);

    // ===== API INTEGRATION STATE =====
    // const [formData, setFormData] = useState({});

    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        mobile_number: "",
        aadhaar_number: "",
        address: "",
        owner_type: "",
        pan_number: "",
        investment_range: "",
        experience_years: "",
        profession: "",
        state: "",
        city: "",
        referred_by: ""

    });

    const [profilePhoto, setProfilePhoto] = useState(null);


    useEffect(() => {
        console.log("formData", formData);
    }, [formData]);

    const handleChange = (value, key) => {
        // 🔢 Number-only fields
        if (
            key === "mobile_number" ||
            key === "aadhaar_number" ||
            key === "experience_years"
        ) {
            // if user typed alphabets/symbols
            if (/[^0-9]/.test(value)) {
                alert("Only numbers are allowed");
            }

            value = value.replace(/[^0-9]/g, "");
        }

        // 📱 Mobile number limit
        if (key === "mobile_number" && value.length > 10) {
            alert("Mobile number must be exactly 10 digits");
            return;
        }

        // 🪪 Aadhaar number limit
        if (key === "aadhaar_number" && value.length > 12) {
            alert("Aadhaar number must be exactly 12 digits");
            return;
        }


        console.log('this is value', value);
        console.log('this is key', key);
        setFormData(prev => ({ ...prev, [key]: value }));
    };


    const handleProfilePhoto = (e) => {
        setProfilePhoto(e.target.files[0]);
    };

    const submitForm = async (role) => {
        try {
            const fd = new FormData();

            fd.append("role", role);
            fd.append("full_name", formData.full_name);
            fd.append("email", formData.email);
            fd.append("mobile_number", formData.mobile_number);
            fd.append("aadhaar_number", formData.aadhaar_number);
            fd.append("aadhaar_verified", "1");
            fd.append('is_admin_approve', "0")


            if (profilePhoto) {
                fd.append("profile_photo", profilePhoto);
            }

            if (role === "owner") {
                fd.append("owner_type", formData.owner_type);
                fd.append("address", formData.address);
                fd.append("gst_number", formData.gst_number);
                fd.append("company_name", formData.company_name);
            }

            if (role === "investor") {
                fd.append("pan_number", formData.pan_number);
                fd.append("investment_range", formData.investment_range);
                fd.append("preferred_locations", "Hyderabad");
                fd.append("referred_by", formData.referred_by);
            }

            if (role === "agent") {
                fd.append("experience_years", formData.experience_years);
                fd.append("profession", formData.profession);
                fd.append("state", formData.state);

                fd.append("city", formData.city);
                fd.append("referred_by", formData.referred_by);
                fd.append("designation", "");
            }
            console.log('this is fd', fd)
             //const res = await fetch("http://localhost:4001/api/register_test", {
              const res = await fetch("https://api.propertygalleria.in/master/api/api/register", {
                method: "POST",
                body: fd
            });

            const data = await res.json();

            if (!res.ok) {
                alert(data.message);
                return;
            }

            alert("Registration successful");
            window.location.href = "/mainlandingpage";

            console.log(data);

        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        }
    };




    const roles = [
        {
            title: "Property Owner",
            desc: "List and sell your land plots",
            bg: "#16a34a",
            border: "#22c55e",
            icon: <AiOutlineHome />,
            role: "owner"
        },
        {
            title: "Investor",
            desc: "Find and invest in properties",
            bg: "#2563eb",
            border: "#3b82f6",
            icon: <BsGraphUpArrow />,
            role: "investor"
        },
        {
            title: "Associate",
            desc: "Connect buyers and sellers",
            bg: "#db2777",
            border: "#ec4899",
            icon: <MdOutlineSupportAgent />,
            role: "agent"
        }
    ];

    const [selectedRole, setSelectedRole] = useState(null);

    const states = State.getStatesOfCountry("IN");


    return (
        <>
            <div className="pg-container">

                <section className="pg-map animate-zoom">
                    <FadeInSection>

                        {/* ROW */}
                        <div className="card-row">

                            {/* LEFT CARD : MAP */}
                            {/* <div className="map-card">
                                <div className="map-wrapper">
                                    <img src={mapImg} alt="Map" className="map-img" />

                                    <div className="map-pin" style={{ top: "25.5%", left: "74.1%" }} onClick={() => navigate("/location/yadadri")} title="Yadadri" />
                                    <div className="map-pin" style={{ top: "34.5%", left: "67.8%" }} onClick={() => navigate("/location/bhuvanagiri")} title="bhuvanagiri" />
                                    <div className="map-pin" style={{ top: "13.2%", left: "68.1%" }} onClick={() => navigate("/location/pragnapur")} title="Pragnapur" />
                                    <div className="map-pin" style={{ top: "7.2%", left: "57.5%" }} onClick={() => navigate("/location/gajwel")} title="Gajwel" />
                                    <div className="map-pin" style={{ top: "4.2%", left: "49.4%" }} onClick={() => navigate("/location/masaipet")} title="Masaipet" />
                                    <div className="map-pin" style={{ top: "11.2%", left: "50.1%" }} onClick={() => navigate("/location/toopran")} title="Toopran" />
                                    <div className="map-pin" style={{ top: "25%", left: "37.2%" }} onClick={() => navigate("/location/narsapur")} title="Narsapur" />
                                    <div className="map-pin" style={{ top: "24.5%", left: "24.8%" }} onClick={() => navigate("/location/sangareddy")} title="sangareddy" />
                                    <div className="map-pin" style={{ top: "41.5%", left: "22.2%" }} onClick={() => navigate("/location/nawabpet")} title="nawabpet" />
                                    <div className="map-pin" style={{ top: "56.5%", left: "34.4%" }} onClick={() => navigate("/location/chevella")} title="chevella" />
                                    <div className="map-pin" style={{ top: "66.5%", left: "31%" }} onClick={() => navigate("/location/shabad")} title="shabad" />
                                    <div className="map-pin" style={{ top: "75.5%", left: "35%" }} onClick={() => navigate("/location/shadnagar")} title="shadnagar" />
                                    <div className="map-pin" style={{ top: "79.5%", left: "42.3%" }} onClick={() => navigate("/location/keshampet")} title="keshampet" />
                                    <div className="map-pin" style={{ top: "89.5%", left: "46.8%" }} onClick={() => navigate("/location/Amangal")} title="Amangal" />
                                    <div className="map-pin" style={{ top: "79.1%", left: "57.8%" }} onClick={() => navigate("/location/nagilla")} title="Nagilla" />
                                    <div className="map-pin" style={{ top: "89.1%", left: "61.4%" }} onClick={() => navigate("/location/mallkurmapally")} title="Mall-Kurmapally" />
                                    <div className="map-pin" style={{ top: "83.1%", left: "70.7%" }} onClick={() => navigate("/location/marrigudem")} title="Marrigudem" />
                                    <div className="map-pin" style={{ top: "73.4%", left: "72.9%" }} onClick={() => navigate("/location/shivannaguda")} title="Shivannaguda" />
                                    <div className="map-pin" style={{ top: "66.6%", left: "75.4%" }} onClick={() => navigate("/location/samsthan-narayanpur")} title="Samsthan Narayanpur" />
                                    <div className="map-pin" style={{ top: "56.2%", left: "76.5%" }} onClick={() => navigate("/location/choutuppal")} title="Choutuppal" />
                                    <div className="map-pin" style={{ top: "46.4%", left: "79.4%" }} onClick={() => navigate("/location/valigonda")} title="Valigonda" />
                                </div>
                            </div> */}

                            <div className="map-card">
                                <div className="map-wrapper">
                                    <img src={mapImg} alt="Map" className="map-img" />

                                    {/* <div className="map-pin" style={{ top: "25.5%", left: "74.1%" }} onClick={() => navigate("/location/yadadri")} title="Yadadri" /> */}
                                    <div className="map-pin" style={{ top: "41.5%", left: "60.8%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "WARANGAL HIGHWAY" }
                                            })}
                                        title="WARANGAL HIGHWAY" />
                                    <div className="map-pin" style={{ top: "51.5%", left: "59.8%" }} title="VIJAYAWADA HIGHWAY" />
                                    onClick={() =>
                                        navigate("/highways", {
                                            state: { highway: "VIJAYAWADA HIGHWAY" }
                                        })}

                                    <div className="map-pin" style={{ top: "57.5%", left: "55.8%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "NAGARJUNA SAGAR HIGHWAY" }
                                            })}
                                        title="NAGARJUNA SAGAR HIGHWAY" />

                                    <div className="map-pin" style={{ top: "60.5%", left: "50%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "SRISAILAM HIGHWAY" }
                                            })}
                                        title="SRISAILAM HIGHWAY" />
                                    <div className="map-pin" style={{ top: "58.5%", left: "44.8%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "BANGLORE HIGHWAY" }
                                            })} title="BANGLORE HIGHWAY" />


                                    <div className="map-pin" style={{ top: "48.5%", left: "45%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "MOINABAD VIKARABAD HIGHWAY" }
                                            })} title="MOINABAD VIKARABAD HIGHWAY" />

                                    {/* <div className="map-pin" style={{ top: "34.5%", left: "67.8%" }} onClick={() => navigate("/location/bhuvanagiri")} title="bhuvanagiri" />
                                                            <div className="map-pin" style={{ top: "13.2%", left: "68.1%" }} onClick={() => navigate("/location/pragnapur")} title="Pragnapur" />
                                                            <div className="map-pin" style={{ top: "7.2%", left: "57.5%" }} onClick={() => navigate("/location/gajwel")} title="Gajwel" />
                                                            <div className="map-pin" style={{ top: "4.2%", left: "49.4%" }} onClick={() => navigate("/location/masaipet")} title="Masaipet" /> */}
                                    <div className="map-pin" style={{ top: "33.2%", left: "38.1%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "MUMBAI HIGHWAY" }
                                            })}
                                        title="MUMBAI HIGHWAY" />
                                    <div className="map-pin" style={{ top: "29.2%", left: "47.1%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "MEDAK HIGHWAY" }
                                            })}
                                        title="MEDAK HIGHWAY" />
                                    <div className="map-pin" style={{ top: "29.2%", left: "51.1%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "Nagpur HIGHWAY" }
                                            })} title="Nagpur highway" />

                                    <div className="map-pin" style={{ top: "30.2%", left: "55.1%" }}
                                        onClick={() =>
                                            navigate("/highways", {
                                                state: { highway: "KARIMNAGAR HIGHWAY" }
                                            })}
                                        title="KARIMNAGAR HIGHWAY" />
                                    {/* <div className="map-pin" style={{ top: "11.2%", left: "50.1%" }} onClick={() => navigate("/location/toopran")} title="Toopran" />
                                                            <div className="map-pin" style={{ top: "25%", left: "37.2%" }} onClick={() => navigate("/location/narsapur")} title="Narsapur" />
                                                            <div className="map-pin" style={{ top: "24.5%", left: "24.8%" }} onClick={() => navigate("/location/sangareddy")} title="sangareddy" />
                                                            <div className="map-pin" style={{ top: "41.5%", left: "22.2%" }} onClick={() => navigate("/location/nawabpet")} title="nawabpet" />
                                                            <div className="map-pin" style={{ top: "56.5%", left: "34.4%" }} onClick={() => navigate("/location/chevella")} title="chevella" />
                                                            <div className="map-pin" style={{ top: "66.5%", left: "31%" }} onClick={() => navigate("/location/shabad")} title="shabad" />
                                                            <div className="map-pin" style={{ top: "75.5%", left: "35%" }} onClick={() => navigate("/location/shadnagar")} title="shadnagar" />
                                                            <div className="map-pin" style={{ top: "79.5%", left: "42.3%" }} onClick={() => navigate("/location/keshampet")} title="keshampet" />
                                                            <div className="map-pin" style={{ top: "89.5%", left: "46.8%" }} onClick={() => navigate("/location/Amangal")} title="Amangal" />
                                                            <div className="map-pin" style={{ top: "79.1%", left: "57.8%" }} onClick={() => navigate("/location/nagilla")} title="Nagilla" />
                                                            <div className="map-pin" style={{ top: "89.1%", left: "61.4%" }} onClick={() => navigate("/location/mallkurmapally")} title="Mall-Kurmapally" />
                                                            <div className="map-pin" style={{ top: "83.1%", left: "70.7%" }} onClick={() => navigate("/location/marrigudem")} title="Marrigudem" />
                                                            <div className="map-pin" style={{ top: "73.4%", left: "72.9%" }} onClick={() => navigate("/location/shivannaguda")} title="Shivannaguda" />
                                                            <div className="map-pin" style={{ top: "66.6%", left: "75.4%" }} onClick={() => navigate("/location/samsthan-narayanpur")} title="Samsthan Narayanpur" />
                                                            <div className="map-pin" style={{ top: "56.2%", left: "76.5%" }} onClick={() => navigate("/location/choutuppal")} title="Choutuppal" />
                                                            <div className="map-pin" style={{ top: "46.4%", left: "79.4%" }} onClick={() => navigate("/location/valigonda")} title="Valigonda" /> */}
                                    {/* {highwayPoints.map((point, index) => (
                                  <div
                                    key={index}
                                  className="map-pin highway-pin"
                                  style={{ top: point.top, left: point.left }}
                                   onClick={() => navigate(point.path)}
                                   title={`Highway Point ${index + 1}`}
                                 />
                                      ))} */}

                                </div>
                            </div>

                            {/* RIGHT CARD : WELCOME */}
                            <div className="welcome-card">


                                <div style={styles.container}>
                                    {/* Back */}


                                    {/* <span style={styles.back} onClick={() => navigate(-1)}>
                                        ← Back
                                    </span> */}

                                    {/* Title */}
                                    {/* <h1 style={styles.title}>Choose Your Role</h1>
                                    <p style={styles.subtitle}>
                                        Select how you want to use PlotHub
                                    </p> */}

                                    {/* Cards */}
                                    {/* <div style={styles.cardWrapper}>
                                        {roles.map((item, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "20px",
                                                    width:'350px',
                                                    padding: "5px",
                                                    borderRadius: "18px",
                                                    backgroundColor: "#ffffff",
                                                    cursor: "pointer",
                                                    transition: "all 0.3s ease",
                                                    border: hoverIndex === index
                                                        ? `2px solid ${item.border}`
                                                        : "2px solid transparent",
                                                    transform: hoverIndex === index
                                                        ? "translateY(-8px) scale(1.02)"
                                                        : "translateY(0)",
                                                    boxShadow: hoverIndex === index
                                                        ? "0 20px 40px rgba(0,0,0,0.15)"
                                                        : "0 10px 25px rgba(0,0,0,0.08)"
                                                }}
                                                onMouseEnter={() => setHoverIndex(index)}
                                                onMouseLeave={() => setHoverIndex(null)}
                                                // onClick={() => navigate(`/signup/${item.role}`)}
                                                onClick={() => setSelectedRole(item.role)}

                                            >
                                                <div
                                                    style={{
                                                        ...styles.iconBox,
                                                        backgroundColor: item.bg
                                                    }}
                                                >
                                                    <span style={styles.icon}>{item.icon}</span>
                                                </div>

                                                <div>
                                                    <h3 style={styles.cardTitle}>{item.title}</h3>
                                                    <p style={styles.cardDesc}>{item.desc}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div> */}



                                    {/* Back Button */}
                                    {selectedRole && (
                                        <span
                                            style={styles.back}
                                            onClick={() => setSelectedRole(null)}
                                        >
                                            ← Back
                                        </span>
                                    )}

                                    {/* ================= ROLE SELECTION ================= */}
                                    {!selectedRole && (
                                        <>

                                            <span style={styles.back} onClick={() => navigate(-1)}>
                                                ← Back
                                            </span>

                                            <h1 style={styles.title}>Choose Your Role</h1>
                                            <p style={styles.subtitle}>
                                                Select how you want to use PlotHub
                                            </p>

                                            <div style={styles.cardWrapper}>
                                                {roles.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "20px",
                                                            width: "330px",
                                                            // padding: "5px",
                                                            borderRadius: "18px",
                                                            backgroundColor: "#ffffff",
                                                            cursor: "pointer",
                                                            transition: "all 0.3s ease",
                                                            border:
                                                                hoverIndex === index
                                                                    ? `2px solid ${item.border}`
                                                                    : "2px solid transparent",
                                                            transform:
                                                                hoverIndex === index
                                                                    ? "translateY(-8px) scale(1.02)"
                                                                    : "translateY(0)",
                                                            boxShadow:
                                                                hoverIndex === index
                                                                    ? "0 20px 40px rgba(0,0,0,0.15)"
                                                                    : "0 10px 25px rgba(0,0,0,0.08)"
                                                        }}
                                                        onMouseEnter={() => setHoverIndex(index)}
                                                        onMouseLeave={() => setHoverIndex(null)}
                                                        onClick={() => setSelectedRole(item.role)}
                                                    >
                                                        <div
                                                            style={{
                                                                ...styles.iconBox,
                                                                backgroundColor: item.bg
                                                            }}
                                                        >
                                                            <span style={styles.icon}>{item.icon}</span>
                                                        </div>

                                                        <div>
                                                            <h3 style={styles.cardTitle}>{item.title}</h3>
                                                            <p style={styles.cardDesc}>{item.desc}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )}

                                    {/* ================= SIGNUP FORMS ================= */}
                                    {selectedRole === "owner" && (
                                        <OwnerSignup
                                            formData={formData}
                                            handleChange={handleChange}
                                            handleProfilePhoto={handleProfilePhoto}
                                            submitForm={submitForm} />
                                    )}
                                    {/* {selectedRole === "investor" && <InvestorSignup />}
                                    {selectedRole === "agent" && <AgentSignup />} */}

                                    {selectedRole === "investor" && (
                                        <InvestorSignup
                                            formData={formData}
                                            handleChange={handleChange}
                                            handleProfilePhoto={handleProfilePhoto}
                                            submitForm={submitForm}
                                        />
                                    )}

                                    {selectedRole === "agent" && (
                                        <AgentSignup
                                            formData={formData}
                                            handleChange={handleChange}
                                            handleProfilePhoto={handleProfilePhoto}
                                            submitForm={submitForm}
                                        />
                                    )}




                                </div>
                            </div>

                        </div>

                    </FadeInSection>
                </section>


            </div>



        </>
    );
};

export default ChooseRole;


const OwnerSignup = ({ formData, handleChange, handleProfilePhoto, submitForm }) => (
    <div style={styles.formContainer}>
        <h2>Sign Up as Property Owner</h2>
        <p>Create your account to get started</p>
        <form style={styles.Overflow} onSubmit={(e) => e.preventDefault()}>
            <input placeholder="Full Name" style={styles.input} value={formData.full_name} onChange={(e) => handleChange(e.target.value, "full_name")} />
            <input placeholder="+91 XXXXX XXXXX" style={styles.input} value={formData.mobile_number} onChange={(e) => handleChange(e.target.value, "mobile_number")} />
            <input placeholder="Email Address" style={styles.input} value={formData.email} onChange={(e) => handleChange(e.target.value, "email")} />
            <input placeholder="Aadhaar Number" style={styles.input} value={formData.aadhaar_number} onChange={(e) => handleChange(e.target.value, "aadhaar_number")} />
            <input placeholder="Address" style={styles.input} value={formData.address} onChange={(e) => handleChange(e.target.value, "address")} />
            {/* <input placeholder="Profile" style={styles.input} /> */}


            <select style={styles.input} value={formData.owner_type} required onChange={(e) => handleChange(e.target.value, "owner_type")}>
                <option>Select the Owner Type</option>

                <option>Individual</option>
                <option>Company</option>
            </select>

            {formData.owner_type === 'Company' && (
                <>
                    <input placeholder="gst_number" style={styles.input} value={formData.gst_number} onChange={(e) => handleChange(e.target.value, "gst_number")} />
                    <input placeholder="company_name" style={styles.input} value={formData.company_name} onChange={(e) => handleChange(e.target.value, "company_name")} />
                </>
            )}


            <div>
                {/* PROFILE PHOTO */}

                <label style={styles.label}>Profile Photo</label>
                <div
                    style={styles.uploadBox}
                    onClick={() => document.getElementById("profilePhoto").click()}
                >
                    <FiUpload size={26} color="#6b7280" />
                    <p style={styles.uploadText}>Click to upload</p>
                </div>
                <input
                    type="file"
                    id="profilePhoto"
                    accept="image/*"
                    value={formData.profilePhoto}
                    style={{ display: "none" }}
                    onChange={handleProfilePhoto}
                />


                {/* PROPERTY OWNERSHIP PROOF */}
                {/* <label style={styles.label1}>Property Ownership Proof</label>
                <div
                    style={styles.uploadBox}
                    onClick={() => document.getElementById("propertyProof").click()}
                >
                    <FiUpload size={26} color="#6b7280" />
                    <p style={styles.uploadText}>Upload documents</p>
                </div>
                <input
                    type="file"
                    id="propertyProof"
                    accept=".pdf,.doc,.docx"
                    style={{ display: "none" }}
                /> */}
            </div>
            <button style={styles.button} onClick={() => submitForm("owner")}>Create Account</button>

        </form>
    </div>
);

// const InvestorSignup = ({ formData, handleChange, handleProfilePhoto, submitForm }) => (
//     <div style={styles.formContainer}>
//         <h2>Sign Up as Investor</h2>
//         <p>Create your account to get started</p>
//         <div style={styles.Overflow} onSubmit={(e) => e.preventDefault()}>
//             <input placeholder="Full Name" style={styles.input} value={formData.full_name} onChange={(e) => handleChange(e.target.value, "full_name")} />
//             <input placeholder="+91 XXXXX XXXXX" style={styles.input} value={formData.mobile_number} onChange={(e) => handleChange(e.target.value, "mobile_number")} />
//             <input placeholder="Email Address" style={styles.input} value={formData.email} onChange={(e) => handleChange(e.target.value, "email")} />
//             <input placeholder="Aadhaar Number" style={styles.input} value={formData.aadhaar_number} onChange={(e) => handleChange(e.target.value, "aadhaar_number")} />
//             <input placeholder="PAN Number" style={styles.input} value={formData.pan_number} onChange={(e) => handleChange(e.target.value, "pan_number")} />

//             <select style={styles.input} value={formData.investment_range} onChange={(e) => handleChange(e.target.value, "investment_range")}>
//                 <option>Select Investment Range</option>
//                 <option>10L - 50L</option>
//                 <option>50L - 1Cr</option>
//             </select>

//             <button style={styles.button} onClick={() => submitForm("investor")}>Create Account</button>

//         </div>
//     </div>
// );


const InvestorSignup = ({ formData, handleChange, handleProfilePhoto, submitForm }) => {

    const [investorReferModal, setInvestorReferModal] = useState(false);
    const [investorReferType, setInvestorReferType] = useState("");

    const [referModalVisible, setReferModalVisible] = useState(false);
    const [referredCode, setReferredCode] = useState("");
    const [referredName, setReferredName] = useState("");

    const [referAgents, setReferAgents] = useState([]);

    // fetch agents
    const fetchAgents = async () => {
        try {
            const res = await axios.get(
                "https://api.propertygalleria.in/master/api/api/agents/referr"
            );

            setReferAgents(res.data.data);

        } catch (error) {
            console.log("Agent API error:", error);
        }
    };

    useEffect(() => {
        fetchAgents();
    }, []);

    return (
        <div style={styles.formContainer}>
            <h2>Sign Up as Investor</h2>
            <p>Create your account to get started</p>

            <div style={styles.Overflow}>

                <input
                    placeholder="Full Name"
                    style={styles.input}
                    value={formData.full_name}
                    onChange={(e) => handleChange(e.target.value, "full_name")}
                />

                <input
                    placeholder="+91 XXXXX XXXXX"
                    style={styles.input}
                    value={formData.mobile_number}
                    onChange={(e) => handleChange(e.target.value, "mobile_number")}
                />

                <input
                    placeholder="Email Address"
                    style={styles.input}
                    value={formData.email}
                    onChange={(e) => handleChange(e.target.value, "email")}
                />

                <input
                    placeholder="Aadhaar Number"
                    style={styles.input}
                    value={formData.aadhaar_number}
                    onChange={(e) => handleChange(e.target.value, "aadhaar_number")}
                />

                <input
                    placeholder="PAN Number"
                    style={styles.input}
                    value={formData.pan_number}
                    onChange={(e) => handleChange(e.target.value, "pan_number")}
                />

                <select
                    style={styles.input}
                    value={formData.investment_range}
                    onChange={(e) => handleChange(e.target.value, "investment_range")}
                >
                    <option>Select Investment Range</option>
                    <option>50L - 1Cr</option>
                    <option>1Cr - 5Cr</option>
                    <option>5Cr+</option>
                </select>


                {/* REFERRED BY */}

                <div style={{ marginTop: '15px' }}>
                    <label style={{ fontSize: "14px", fontWeight: "500", margin: '5px' }}>
                        Referred By
                    </label>

                    <span
                        style={styles.input}
                        onClick={() => setInvestorReferModal(true)}
                    >
                        {investorReferType || "Select"}
                    </span>
                </div>




                {/* REFER TYPE MODAL */}

                {investorReferModal && (
                    <div style={styles.modalOverlay}>

                        <div style={styles.modalBox}>

                            <h3>Select Referral Type</h3>

                            {["Referral Code", "Friend", "Website", "Social Media"].map(
                                (item) => (
                                    <div
                                        key={item}
                                        style={styles.modalItem}
                                        onClick={() => {
                                            setInvestorReferType(item);
                                            setInvestorReferModal(false);
                                        }}
                                    >
                                        {item}
                                    </div>
                                )
                            )}

                            <button
                                style={styles.closeBtn}
                                onClick={() => setInvestorReferModal(false)}
                            >
                                Close
                            </button>

                        </div>
                    </div>
                )}


                {/* AGENT SELECT */}

                {investorReferType === "Referral Code" && (
                    <div style={{ marginTop: '15px' }}>

                        <label style={{ fontSize: "14px", fontWeight: "500" }}>
                            Select Agent
                        </label>

                        <span
                            style={styles.input}
                            onClick={() => setReferModalVisible(true)}
                        >
                            {referredName || "Select Agent"}
                        </span>

                    </div>
                )}


                {/* AGENT MODAL */}

                {referModalVisible && (
                    <div style={styles.modalOverlay}>

                        <div style={styles.agentModal}>

                            <h3>Select Agent</h3>

                            <div style={styles.agentList}>

                                {referAgents.map((item) => {

                                    const isSelected = referredCode === item.code_id;

                                    return (
                                        <div
                                            key={item.code_id}
                                            style={{
                                                ...styles.agentItem,
                                                background: isSelected ? "#2563eb" : "#fff",
                                                color: isSelected ? "#fff" : "#000"
                                            }}

                                            onClick={() => {
                                                setReferredCode(item.code_id);
                                                setReferredName(`${item.code_id} - ${item.name}`);
                                                handleChange(item.code_id, "referred_by");
                                                setReferModalVisible(false);
                                            }}
                                        >
                                            {item.code_id} - {item.name}
                                        </div>
                                    );
                                })}

                            </div>

                            <button
                                style={styles.closeBtn}
                                onClick={() => setReferModalVisible(false)}
                            >
                                Close
                            </button>

                        </div>
                    </div>
                )}

                <div>
                    {/* PROFILE PHOTO */}

                    <label style={styles.label}>Profile Photo</label>
                    <div
                        style={styles.uploadBox}
                        onClick={() => document.getElementById("profilePhoto").click()}
                    >
                        <FiUpload size={26} color="#6b7280" />
                        <p style={styles.uploadText}>Click to upload</p>
                    </div>
                    <input
                        type="file"
                        id="profilePhoto"
                        accept="image/*"
                        value={formData.profilePhoto}
                        style={{ display: "none" }}
                        onChange={handleProfilePhoto}
                    />


                    {/* PROPERTY OWNERSHIP PROOF */}
                    {/* <label style={styles.label1}>Property Ownership Proof</label>
                <div
                    style={styles.uploadBox}
                    onClick={() => document.getElementById("propertyProof").click()}
                >
                    <FiUpload size={26} color="#6b7280" />
                    <p style={styles.uploadText}>Upload documents</p>
                </div>
                <input
                    type="file"
                    id="propertyProof"
                    accept=".pdf,.doc,.docx"
                    style={{ display: "none" }}
                /> */}
                </div>
                <button
                    style={styles.button}
                    onClick={() => submitForm("investor")}
                >
                    Create Account
                </button>

            </div>
        </div>
    );
};

const AgentSignup = ({ formData, handleChange, handleProfilePhoto, submitForm }) => {
    const states = State.getStatesOfCountry("IN");

    const [investorReferModal, setInvestorReferModal] = useState(false);
    const [investorReferType, setInvestorReferType] = useState("");

    const [referModalVisible, setReferModalVisible] = useState(false);
    const [referredCode, setReferredCode] = useState("");
    const [referredName, setReferredName] = useState("");

    const [referAgents, setReferAgents] = useState([]);

    // fetch agents
    const fetchAgents = async () => {
        try {
            const res = await axios.get(
                "https://api.propertygalleria.in/master/api/api/agents/referr"
            );

            setReferAgents(res.data.data);

        } catch (error) {
            console.log("Agent API error:", error);
        }
    };

    useEffect(() => {
        fetchAgents();
    }, []);
    return (

        <div style={styles.formContainer}>
            <h2 style={styles.h2}>Sign Up as Associate</h2>
            <p style={styles.p}>Create your account to get started</p>
            <div style={styles.Overflow}>
                <input placeholder="Full Name" style={styles.input} value={formData.full_name} onChange={(e) => handleChange(e.target.value, "full_name")} />
                <input placeholder="+91 XXXXX XXXXX" style={styles.input} value={formData.mobile_number} maxLength={10}
                    inputMode="numeric" onChange={(e) => handleChange(e.target.value, "mobile_number")} />
                <input placeholder="Email Address" style={styles.input} value={formData.email} onChange={(e) => handleChange(e.target.value, "email")} />
                <input placeholder="Aadhaar Number" style={styles.input} maxLength={12}
                    inputMode="numeric" value={formData.aadhaar_number} onChange={(e) => handleChange(e.target.value, "aadhaar_number")} />
                <input placeholder="Experience (years)" style={styles.input} inputMode="numeric" value={formData.experience_years}
                    onChange={(e) => handleChange(e.target.value, "experience_years")} />

                {/* <label style={styles.label}>
                    Profession <span style={styles.required}>*</span>
                </label> */}
                <input
                    type="profession"
                    value={formData.profession}
                    // onChange={(e) => handleChange({ ...formData, profession: e.target.value })}
                    onChange={(e) => handleChange(e.target.value, "profession")}
                    placeholder="Enter your Profession"
                    style={styles.input}
                    required
                />

                {/* <label style={styles.label}>State</label> */}
                <select
                    style={styles.input}
                    value={formData.state}
                    //   onChange={(e) =>
                    //     handleChange({
                    //       ...formData,
                    //       state: e.target.value,
                    //       city: "" // reset city when state changes
                    //     })
                    //   }
                    onChange={(e) => {
                        handleChange(e.target.value, "state");
                        handleChange("", "city"); // reset city when state changes
                    }}
                    required
                >
                    <option value="">Select State</option>
                    {states.map((state) => (
                        <option key={state.isoCode} value={state.isoCode}>
                            {state.name}
                        </option>
                    ))}
                </select>

                {/* <label style={styles.label}>City</label> */}
                <select
                    style={styles.input}
                    value={formData.city}
                    //   onChange={(e) =>
                    //     handleChange({ ...formData, city: e.target.value })
                    //   }
                    onChange={(e) => handleChange(e.target.value, "city")}
                    required
                    disabled={!formData.state}
                >
                    <option value="">Select City</option>
                    {City.getCitiesOfState("IN", formData.state).map((city) => (
                        <option key={city.name} value={city.name}>
                            {city.name}
                        </option>
                    ))}
                </select>


                {/* REFERRED BY */}

                <div style={{ marginTop: '15px' }}>
                    <label style={{ fontSize: "14px", fontWeight: "500", margin: '5px' }}>
                        Referred By
                    </label>

                    <span
                        style={styles.input}
                        onClick={() => setInvestorReferModal(true)}
                    >
                        {investorReferType || "Select"}
                    </span>
                </div>


                {/* REFER TYPE MODAL */}

                {investorReferModal && (
                    <div style={styles.modalOverlay}>

                        <div style={styles.modalBox}>

                            <h3>Select Referral Type</h3>

                            {["Referral Code", "Friend", "Website", "Social Media"].map(
                                (item) => (
                                    <div
                                        key={item}
                                        style={styles.modalItem}
                                        onClick={() => {
                                            setInvestorReferType(item);
                                            setInvestorReferModal(false);
                                        }}
                                    >
                                        {item}
                                    </div>
                                )
                            )}

                            <button
                                style={styles.closeBtn}
                                onClick={() => setInvestorReferModal(false)}
                            >
                                Close
                            </button>

                        </div>
                    </div>
                )}


                {/* AGENT SELECT */}

                {investorReferType === "Referral Code" && (
                    <div style={{ marginTop: '15px' }}>

                        <label style={{ fontSize: "14px", fontWeight: "500" }}>
                            Select Agent
                        </label>

                        <span
                            style={styles.input}
                            onClick={() => setReferModalVisible(true)}
                        >
                            {referredName || "Select Agent"}
                        </span>

                    </div>
                )}


                {/* AGENT MODAL */}

                {referModalVisible && (
                    <div style={styles.modalOverlay}>

                        <div style={styles.agentModal}>

                            <h3>Select Agent</h3>

                            <div style={styles.agentList}>

                                {referAgents.map((item) => {

                                    const isSelected = referredCode === item.code_id;

                                    return (
                                        <div
                                            key={item.code_id}
                                            style={{
                                                ...styles.agentItem,
                                                background: isSelected ? "#2563eb" : "#fff",
                                                color: isSelected ? "#fff" : "#000"
                                            }}

                                            onClick={() => {
                                                setReferredCode(item.code_id);
                                                setReferredName(`${item.code_id} - ${item.name}`);
                                                handleChange(item.code_id, "referred_by");
                                                setReferModalVisible(false);
                                            }}
                                        >
                                            {item.code_id} - {item.name}
                                        </div>
                                    );
                                })}

                            </div>

                            <button
                                style={styles.closeBtn}
                                onClick={() => setReferModalVisible(false)}
                            >
                                Close
                            </button>

                        </div>
                    </div>
                )}

                <div>
                    {/* PROFILE PHOTO */}

                    <label style={styles.label}>Profile Photo</label>
                    <div
                        style={styles.uploadBox}
                        onClick={() => document.getElementById("profilePhoto").click()}
                    >
                        <FiUpload size={26} color="#6b7280" />
                        <p style={styles.uploadText}>Click to upload</p>
                    </div>
                    <input
                        type="file"
                        id="profilePhoto"
                        accept="image/*"
                        value={formData.profilePhoto}
                        style={{ display: "none" }}
                        onChange={handleProfilePhoto}
                    />


                    {/* PROPERTY OWNERSHIP PROOF */}
                    {/* <label style={styles.label1}>Property Ownership Proof</label>
                <div
                    style={styles.uploadBox}
                    onClick={() => document.getElementById("propertyProof").click()}
                >
                    <FiUpload size={26} color="#6b7280" />
                    <p style={styles.uploadText}>Upload documents</p>
                </div>
                <input
                    type="file"
                    id="propertyProof"
                    accept=".pdf,.doc,.docx"
                    style={{ display: "none" }}
                /> */}
                </div>


                <button style={styles.button} onClick={() => submitForm("agent")}>Create Account</button>
            </div>
        </div>

    )
};

const styles = {
    container: {
        // minHeight: "100vh",
        // padding: "24px",
        fontFamily: "Inter, sans-serif",
        backgroundColor: "#fff"
    },
    back: {
        cursor: "pointer",
        fontSize: "16px",
        color: "#374151"
    },
    title: {
        textAlign: "center",
        fontSize: "32px",
        fontWeight: "700",
        marginTop: "30px"
    },
    subtitle: {
        textAlign: "center",
        color: "#6b7280",
        marginBottom: "40px"
    },
    cardWrapper: {
        // width: "520px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "22px",
        padding: '0px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    // carddCR: {
    //     display: "flex",
    //     alignItems: "center",
    //     gap: "20px",
    //     padding: "22px",
    //     borderRadius: "18px",
    //     backgroundColor: "#ffffff",
    //     cursor: "pointer",
    //     transition: "all 0.3s ease"
    // },
    iconBox: {
        width: "58px",
        height: "58px",
        borderRadius: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    icon: {
        fontSize: "26px",
        color: "#fff",
    },
    cardTitle: {
        fontSize: "18px",
        fontWeight: "600",
        marginBottom: "6px"
    },
    cardDesc: {
        fontSize: "14px",
        color: "#6b7280"
    },

    formContainer: {
        maxHeight: "400px",

        paddingRight: "10px"
    },
    Overflow: {
        overflowY: "auto",
        maxHeight: "325px",

        paddingRight: "10px"
    },
    input: {
        width: "70%",
        padding: "10px",
        marginTop: "14px",
        borderRadius: "12px",
        border: "1px solid #d1d5db",
        fontSize: "14px"
    },
    button: {
        width: "50%",
        marginTop: "24px",
        padding: "5px",
        backgroundColor: "#2563eb",
        color: "#fff",
        border: "none",
        borderRadius: "14px",
        fontSize: "16px",
        cursor: "pointer"
    },
    label: {
        marginTop: "18px",
        fontSize: "14px",
        fontWeight: "500"
    },
    label1: {
        marginTop: "1px",
        fontSize: "14px",
        fontWeight: "500"
    },
    uploadBox: {
        marginTop: "10px",
        border: "2px dashed #cbd5f5",
        borderRadius: "14px",
        height: "120px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: "#f9fafb",
        transition: "all 0.3s ease"
    },
    uploadText: {
        marginTop: "8px",
        color: "#6b7280",
        fontSize: "14px"
    },

    dropdown: {
        marginTop: "10px",
        border: "1px solid #d1d5db",
        // padding: "10px",
        borderRadius: "10px",
        cursor: "pointer",
        background: "#fff"
    },

    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
    },

    modalBox: {
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        width: "300px",
        textAlign: "center"
    },

    modalItem: {
        padding: "12px",
        borderBottom: "1px solid #eee",
        cursor: "pointer"
    },

    agentModal: {
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        width: "350px"
    },

    agentList: {
        maxHeight: "250px",
        overflowY: "auto",
        marginTop: "10px"
    },

    agentItem: {
        padding: "10px",
        borderBottom: "1px solid #eee",
        cursor: "pointer"
    },

    closeBtn: {
        marginTop: "15px",
        padding: "8px 14px",
        border: "none",
        background: "#2563eb",
        color: "#fff",
        borderRadius: "8px",
        cursor: "pointer"
    }

};
